import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Tooltip } from "@mui/material";
import { Accordion, Form, Modal } from "react-bootstrap";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import ApprovalOutlined from "@mui/icons-material/ApprovalOutlined";

import Utility from "../../utility/utility";
import NoPermission from "../common/noPermission";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import WorkerProxy from "../../utility/proxy/worker/workerProxy";
import AddCertificateModal from "./addCertificateModal";
import CommonStoneSelection from "../common/commonStoneSelection";

import renderCellExpand from "../common/dataGridCellExpand";
import logo from "../../images/pansuriya.jpg";
import ShowLabStatsModal from "./showLabStatsModal";
import { LoadingButton } from "@mui/lab";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PageTitle from "../common/pageTitle";

export default function GIAMaster() {
    const statusOptions = [
        { value: "NEW", label: "NEW" },
        { value: "FAILED", label: "FAILED" },
        { value: "PROCESSED", label: "PROCESSED" },
        { value: "RETRY", label: "RETRY" },
        { value: "IN_PROGRESS", label: "IN_PROGRESS" },
        { value: "LATER", label: "LATER" },
        { value: "PARK1", label: "PARK1" },
        { value: "PARK2", label: "PARK2" },
        { value: "PARK3", label: "PARK3" },
    ];
    const [access, setAccess] = useState(false);
    const [formData, setFormData] = useState({
        fromDate: "",
        toDate: "",
        status: statusOptions.filter((s) => (s.value === "LATER"))[0],
        limit: "",
    });
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [certificateId, setCertificateId] = useState("");
    const [data, setData] = useState([]);
    const [giaLoader, setGiaLoader] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [show, setShow] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [showMoveToModal, setShowMoveToModal] = useState(false);
    const [selectedMoveToStatus, setSelectedMoveToStatus] = useState(false);
    const [local_Permission,] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.WORKER_GIA
        )
    );
    const [showStats, setShowStats] = useState(false);
    const [labStats, setLabStats] = useState([]);
    const [showStatsError, setShowStatsError] = useState(false);
    const [columns, setColumns] = useState([]);
    const [filterValues, setFilterValues] = useState({});
    const [moveToLoader, setMoveToLoader] = useState(false);

    useEffect(() => {
        PageTitle("WORKER_GIA");
        checkPermission();
    }, []);

    useEffect(() => {
        const localStorageKey = `${window.location.pathname.split('/').pop()}_ColumnOrder`;
        const savedColumnOrder = JSON.parse(localStorage.getItem(localStorageKey));

        const originalColumns = initialColumns();
        Utility.applySavedColumnOrder(savedColumnOrder, originalColumns, setColumns);
    }, [data]);

    const checkPermission = () => {
        let allowed = Utility.isReadAllowed(local_Permission)
        if (!allowed) {
            setAccess(true)
            return <NoPermission />
        }
        else {
            setFormData({
                ...formData,
                fromDate: '',
                toDate: '',
            });
        }
    }

    const fetchhandler = (certificateId) => {
        let { fromDate, toDate, limit, status } = formData;
        const lCertificateId = certificateId !== null && certificateId.trim() !== '' ? certificateId.replaceAll(' ', "").split(',').filter((c) => c.trim() !== '') : [];

        setGiaLoader(true);
        let uStartTime = "";
        let uEndTime = "";
        if (fromDate !== null && fromDate !== '') {
            uStartTime = Utility.ConvertLocalTimeToUtc(fromDate);
        }
        if (toDate !== null && toDate !== '') {
            uEndTime = Utility.ConvertLocalTimeToUtc(toDate);
        }
        WorkerProxy.GetFilteredGia(
            status.value,
            uStartTime,
            uEndTime,
            limit,
            lCertificateId,
            (responseData) => {
                if (responseData) {
                    const uniqueFilterValues = {
                        shape: Utility.getDistinctOptions(responseData, "shape"),
                        culteSize: Utility.getDistinctOptions(responseData, "culteSize"),
                        intensityLongtitle: Utility.getDistinctOptions(responseData, "intensityLongtitle"),
                        gridleMin: Utility.getDistinctOptions(responseData, "gridleMin"),
                        open: Utility.getDistinctOptions(responseData, "open"),
                        cutpolsym: Utility.getDistinctOptions(responseData, "cutpolsym"),
                        white: Utility.getDistinctOptions(responseData, "white"),
                        culetcondition: Utility.getDistinctOptions(responseData, "culet_condition"),
                        cut: Utility.getDistinctOptions(responseData, "cut"),
                        polish: Utility.getDistinctOptions(responseData, "polish"),
                        symmetry: Utility.getDistinctOptions(responseData, "symmetry"),
                        color: Utility.getDistinctOptions(responseData, "color"),
                        clarity: Utility.getDistinctOptions(responseData, "clarity"),
                    };
                    setFilterValues(uniqueFilterValues);
                    setData(responseData);
                    setGiaLoader(false);
                    setSelectionModel([]);
                } else {
                    setErrorSnackbar(true)
                    setGiaLoader(false);
                }
            }
        );
    };

    const addCertificate = (certificateIds, ids) => {
        setCertificateId(ids);
        setFormData({ ...formData, fromDate: null, toDate: null });
        setLoadingButton(true);
        WorkerProxy.AddGiaCertificate(certificateIds, (responseData) => {
            if (responseData) {
                setData([]);
                setShowSuccessSnackbar(true);
                setLoadingButton(false);
                setShow(false);
            } else {
                setErrorSnackbar(true);
                setLoadingButton(false);
            }
        });
    };

    const handleValidation = (certificateIds) => {
        //TODO do validation if needed here
        return true;
    };

    const handleClose = () => {
        setShowSuccessSnackbar(false);
    };

    const getDataHandler = (e) => {
        e.preventDefault();
        fetchhandler(certificateId);
    };

    const handleOpen = () => {
        setShow(!show);
        setShowSuccessSnackbar(false);
    };

    const handleSelection = (data) => {
        let value = Utility.StringToIntegerArray(data)
        setSelectionModel([...selectionModel, ...value])
    }

    const handleModalClose = () => {
        setShowMoveToModal(false);
    };

    const handleMoveToAnotherStatus = (selectedMoveToStatus) => {
        setMoveToLoader(true);
        let oldstatus = '';
        let newstatus = selectedMoveToStatus.value;
        data.map((item) => {
            if (selectionModel.includes(item.certificateid)) oldstatus = item.status
            return true;
        })
        WorkerProxy.GetChangeGiaCertificateStatus(
            oldstatus, newstatus, selectionModel,
            (res) => {
                if (res) {
                    handleModalClose();
                    setShowSuccessSnackbar(true);
                    fetchhandler(certificateId);
                    setMoveToLoader(false);
                }
            }
        )
    }

    const initialColumns = () => [
        {
            field: "id",
            headerName: "ID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            minWidth: 50,
        },
        {
            field: "userid",
            hheaderName: "USER ID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            minWidth: 50,
        },
        {
            field: "certificateid",
            headerName: "CERT",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.cut : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "polish",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.polish : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "symmetry",
            headerName: "SYM",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.symmetry : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.color : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            width: 105,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.clarity : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            width: 130,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.shape : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.size))
        },
        {
            field: "status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
        },
        {
            field: "comment",
            headerName: "COMMENT",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            renderCell: renderCellExpand,
        },
        {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            minWidth: 190,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        {
            field: "crownHeight",
            headerName: "CR.HEIGHT",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            renderCell: renderCellExpand,
        },
        {
            field: "crownAngle",
            headerName: "CROWNANGLE",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "culteSize",
            headerName: "CULET SZ",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.culteSize : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "culet_condition",
            headerName: "CULETCONDITION",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.culetcondition : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "depthPercent",
            headerName: "DEPTH%",
            headerAlign: "center",
            align: "center",
            width: 75,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "gridleMin",
            headerName: "GIRDLEMIN",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.gridleMin : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "girdlePercent",
            headerName: "GIRDLEPERCENT",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "girdleCondition",
            headerName: "GIRDLECONDITION",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            renderCell: renderCellExpand,
        },
        {
            field: "white",
            headerName: "WHITE",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.white : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "open",
            headerName: "OPEN",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.open : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "cutpolsym",
            headerName: "CUTPOLSYM",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.cutpolsym : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "intensityLongtitle",
            headerName: "INTENSITYLONGTITLE",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.intensityLongtitle : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "laserincription",
            headerName: "INS",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            renderCell: renderCellExpand,
        },
        {
            field: "measurements",
            headerName: "MEASUREMENTS",
            headerAlign: "center",
            align: "center",
            width: 140,
            renderCell: renderCellExpand,
        },
        {
            field: "note",
            headerName: "NOTE",
            headerAlign: "center",
            align: "center",
            minWidth: 180,
            renderCell: renderCellExpand,
        },
        {
            field: "pavilionDepth",
            headerName: "PV.DEPTH",
            headerAlign: "center",
            align: "center",
            minWidth: 180,
            renderCell: renderCellExpand,
        },
        {
            field: "pavilionAngle",
            headerName: "PAVILIONANGLE",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "reportdate",
            headerName: "REPORT DATE",
            headerAlign: "center",
            align: "center",
            minWidth: 190,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        {
            field: "tablepercent",
            headerName: "TABLE%",
            headerAlign: "center",
            align: "center",
            width: 75,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "updatedat",
            headerName: "UPDATE DATE",
            headerAlign: "center",
            align: "center",
            minWidth: 190,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
    ];

    const rows = data;
    const finalColumns = Utility.isUpdateAllowed(local_Permission)
        ? columns
        : columns.filter((col) => col.field !== "edit");

    const handleShowStats = () => setShowStats(true);

    const getGiaStats = () => {
        setLoadingButton(true);
        WorkerProxy.GetAllGiaStats((response) => {
            if (response) {
                const total = response.reduce((acc, curr) => acc + curr.count, 0);
                const totalObject = { status: "TOTAL", count: total };
                const updatedResponse = [...response, totalObject];
                setLabStats(updatedResponse);
                setLoadingButton(false);
            } else {
                setErrorSnackbar(true);
                setLoadingButton(false);

            }
        });
    }

    return (
        <Box>
            {access ? <NoPermission /> : (
                <div>
                    <Box className="d-flex flex-row pt-1" style={{ width: "100%" }}>
                        {handleValidation ? (
                            <CommonSnackbar
                                show={showSuccessSnackbar}
                                message="Certificates added Successfully"
                                variant={"success"}
                                autoHide={Constants.SnackBarCloseTimer}
                                handleClose={handleClose}
                                title="Success"
                            />
                        ) : null}

                        {showSuccessSnackbar ? (
                            <CommonSnackbar
                                show={showSuccessSnackbar}
                                message="Status Updated Successfully"
                                variant={"success"}
                                autoHide={Constants.SnackBarCloseTimer}
                                handleClose={handleClose}
                                title="Success"
                            />
                        ) : null}

                        <CommonSnackbar
                            show={errorSnackbar}
                            message={Constants.APiFailErrorMessage}
                            variant={"error"}
                            autoHide={Constants.SnackBarCloseTimer}
                            title={"Error"}
                            handleClose={() => setErrorSnackbar(false)}
                        />

                        <Box style={{ width: '100%', display: 'flex' }}>
                            <Box className="ms-2" style={{ width: '-webkit-fill-available' }}>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filter GIA Master</Accordion.Header>

                                        <Accordion.Body>
                                            <Form>
                                                <Box className="row">
                                                    <Box className="col">
                                                        <Form.Group className="mb-3 d-flex">
                                                            <Form.Label className="mt-2 me-2">FROM</Form.Label>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DateTimePicker
                                                                    ampm={true}
                                                                    renderInput={(props) => (
                                                                        <TextField
                                                                            fullWidth
                                                                            {...props}
                                                                            inputProps={{
                                                                                ...props.inputProps,
                                                                                readOnly: true,
                                                                            }}
                                                                        />
                                                                    )}
                                                                    label="Certificate Created From"
                                                                    value={formData.fromDate}
                                                                    inputFormat="DD/MM/YYYY hh:mm:ss a"
                                                                    onChange={(newValue) => {
                                                                        setFormData({
                                                                            ...formData,
                                                                            fromDate: newValue.$d,
                                                                        });
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </Form.Group>
                                                    </Box>
                                                    <Box className="col">
                                                        {" "}
                                                        <Form.Group className="mb-3 d-flex flex-row">
                                                            <Form.Label className="mt-2 me-2 ms-4">
                                                                TO
                                                            </Form.Label>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DateTimePicker
                                                                    ampm={true}
                                                                    renderInput={(props) => (
                                                                        <TextField
                                                                            fullWidth
                                                                            {...props}
                                                                            inputProps={{
                                                                                ...props.inputProps,
                                                                                readOnly: true,
                                                                            }}
                                                                        />
                                                                    )}
                                                                    error={false}
                                                                    label="Certificate Created To"
                                                                    value={formData.toDate}
                                                                    inputFormat="DD/MM/YYYY hh:mm:ss a"
                                                                    onChange={(newValue) => {
                                                                        setFormData({
                                                                            ...formData,
                                                                            toDate: newValue.$d,
                                                                        });
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </Form.Group>
                                                    </Box>
                                                </Box>
                                                <Box className="row">
                                                    <Box className="col">
                                                        <Form.Group className="mb-3 d-flex flex-row">
                                                            <Form.Label className="mt-2 me-2">Status</Form.Label>
                                                            <Box style={{ width: "100%" }}>
                                                                <Select menuPlacement="auto"
                                                                    blurInputOnSelect={false}
                                                                    defaultValue={formData.status}
                                                                    menuPortalTarget={document.body}
                                                                    styles={Constants.Styles}
                                                                    options={statusOptions}
                                                                    onChange={(e) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            status: e,
                                                                        })
                                                                    }
                                                                />
                                                            </Box>
                                                        </Form.Group>
                                                    </Box>
                                                    <Box className="col">
                                                        <Form.Group className="mb-3 d-flex flex-row">
                                                            <Form.Label className="mt-2 me-2 ms-2">
                                                                Limit
                                                            </Form.Label>
                                                            <TextField
                                                                type="number"
                                                                inputProps={{
                                                                    inputMode: "numeric",
                                                                    pattern: "[0-9]*",
                                                                }}
                                                                placeholder="Enter Limit"
                                                                fullWidth
                                                                label="Limit"
                                                                value={formData.limit}
                                                                onChange={(e) =>
                                                                    setFormData({
                                                                        ...formData,
                                                                        limit: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Box>
                                                </Box>
                                                <Box className="row">
                                                    {/* <Box className="col"> */}
                                                    <Form.Group
                                                        className="mb-3 d-flex flex-row justify-content-between no-wrap"
                                                        style={{ width: "100%" }}
                                                    >
                                                        <Box style={{ width: "7%" }}>
                                                            <Form.Label className="mt-2">
                                                                Certificate ID
                                                            </Form.Label>
                                                        </Box>
                                                        <Box style={{ width: "93%" }}>
                                                            <TextField
                                                                id="outlined-multiline-static"
                                                                label="Enter Certificate ID"
                                                                placeholder="Comma seperated Certificate Ids"
                                                                multiline
                                                                fullWidth
                                                                rows={4}
                                                                value={certificateId}
                                                                onChange={(e) =>
                                                                    setCertificateId(
                                                                        Utility.ConvertNewLineToComma(e.target.value)
                                                                    )
                                                                }
                                                            />
                                                        </Box>
                                                    </Form.Group>
                                                    {/* </Box> */}
                                                </Box>
                                                <Box className="d-flex justify-content-end flex-nowrap mt-3">
                                                    <LoadingButton
                                                        variant="contained"
                                                        onClick={getDataHandler}
                                                        loading={giaLoader}
                                                        loadingPosition="start"
                                                        startIcon={<ManageSearchIcon />}
                                                        type="submit"
                                                    >
                                                        Get Data
                                                    </LoadingButton>
                                                </Box>
                                            </Form>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Box>
                            <Box style={{ width: "250px", marginLeft: '20px' }}>
                                {Utility.isAddAllowed(local_Permission) ? (
                                    <Button variant="contained" onClick={handleOpen}>
                                        Add Certificates
                                    </Button>
                                ) : null}
                                {show && (
                                    <AddCertificateModal
                                        show={show}
                                        setShow={setShow}
                                        handleValidation={handleValidation}
                                        handleSave={addCertificate}
                                        loading={loadingButton}
                                    />
                                )}
                            </Box>
                            <Box style={{ width: "200px", marginLeft: '20px' }}>
                                <Button variant="contained" onClick={handleShowStats}>
                                    Show Stats
                                </Button>
                                {showStats && (
                                    <ShowLabStatsModal
                                        show={showStats}
                                        setShow={setShowStats}
                                        handleStats={getGiaStats}
                                        labStats={labStats}
                                        setLabStats={setLabStats}
                                        loading={loadingButton}
                                        setLoadingButton={setLoadingButton}
                                        labName={"GIA"}
                                        showStatsError={showStatsError}
                                        setShowStatsError={setShowStatsError}
                                    />
                                )}
                            </Box>
                        </Box>
                    </Box>

                    <Box px={1} pt={1}>
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                height: "80vh",
                            }}>
                            <DataGridPro
                                disableRowSelectionOnClick={true}
                                getRowHeight={() => "auto"}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "4px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },

                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                density="compact"
                                slots={{ toolbar: GridToolbar }}
                                rows={rows}
                                columns={finalColumns}
                                getRowId={(row) => row.certificateid}
                                checkboxSelection={Utility.isUpdateAllowed(local_Permission) ? true : false}
                                onRowSelectionModelChange={(newSelectionModel) => {
                                    setSelectionModel(newSelectionModel);
                                }}
                                rowSelectionModel={selectionModel}
                                onColumnOrderChange={(params) => Utility.handleColumnOrderChange(params, columns, setColumns, window.location.pathname)}
                                loading={giaLoader}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            // Hide columns id, the other columns will remain visible
                                            id: false,
                                            userid: false,
                                        },
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                            <Box sx={{
                                position: "absolute",
                                left: "0.4rem",
                                top: "1px"
                            }}>
                                <CommonStoneSelection
                                    title={"Enter multiple Certificate Ids"}
                                    handleSelection={handleSelection}
                                    buttonDisabled={rows.length === 0}
                                />
                            </Box>
                            <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                                {giaLoader ? (
                                    <CircularProgress size="1rem" />
                                ) : (
                                    <Tooltip title="Reload List">
                                        <RefreshOutlinedIcon
                                            onClick={() =>
                                                fetchhandler(certificateId)
                                            }
                                            color="primary"
                                            fontSize="medium"
                                            sx={{ cursor: "pointer" }}
                                        />
                                    </Tooltip>
                                )}

                                {Utility.isUpdateAllowed(local_Permission) ? (
                                    <Tooltip title="Move To">
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            component="label"
                                            sx={{ ml: "5px" }}
                                            startIcon={<ApprovalOutlined size="large" />}
                                            color="success"
                                            disabled={selectionModel.length < 1}
                                            onClick={() => setShowMoveToModal(true)}>
                                            Move To
                                        </Button>
                                    </Tooltip>
                                ) : null}

                                {showMoveToModal ?
                                    <Modal
                                        show={showMoveToModal}
                                        onHide={handleModalClose}
                                        backdrop="static"
                                        keyboard={true}
                                        customer="lg"
                                        centered
                                        enforceFocus={false}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>
                                                <img
                                                    src={logo}
                                                    height="40pt"
                                                    width="40pt"
                                                    alt={Constants.COMPANY_SITE}
                                                />
                                                &nbsp;&nbsp;&nbsp;&nbsp;Move To
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Box sx={{ display: "flex", flex: 1, gap: "10px", alignItems: 'center' }}>
                                                <Form.Label>Move To : </Form.Label>
                                                <Box style={{ flex: 1 }}>
                                                    <Select menuPlacement="auto"
                                                        blurInputOnSelect={false}
                                                        menuPortalTarget={document.body}
                                                        styles={Constants.Styles}
                                                        options={statusOptions.filter((item) => (
                                                            item.value !== '' &&
                                                            item.value !== 'PROCESSED' &&
                                                            item.value !== formData.status.value
                                                        ))}
                                                        onChange={(e) => setSelectedMoveToStatus(e)}
                                                    />
                                                </Box>
                                            </Box>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <LoadingButton
                                                loading={moveToLoader}
                                                loadingPosition="start"
                                                startIcon={<ApprovalOutlined size="large" />}
                                                variant="contained"
                                                color="info"
                                                onClick={() => handleMoveToAnotherStatus(selectedMoveToStatus)}
                                                sx={{ mr: 2 }}>
                                                Move
                                            </LoadingButton>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={handleModalClose}
                                                sx={{ mr: 2 }}
                                                disabled={moveToLoader}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                    : null}
                            </Box>
                        </Box>
                    </Box>
                </div>
            )}
        </Box>
    )
}